// Module
var code = "<div id=\"download\">\n</div>";
// Exports
module.exports = code;